module.exports = __webpack_public_path__ + "img/support.250f821a.svg";